import axios from 'axios';

const state = {
	items: [],
	options: null,
};

const getters = {
	getItems: state => state.items,
	getOptions: state => state.options,
};

const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });
const url = (context, path) => `${context.rootGetters['settings/getUrl']}${path}`;

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		return axios
			.post(
				url(context, 'socialposts'),
				{ data: { sortBy: sortBy[0], sortDesc: sortDesc[0] ? 1 : 0, page, itemsPerPage, search: settings.search, status: (settings.filters && settings.filters.status) || '' } },
				auth(context),
			)
			.then(res => {
				context.commit('setItems', res.data.data);
				return res.data.pagination;
			})
			.catch(err => console.log('errore', err));
	},
	// layout, formati, social e preset colori: non cambiano, si leggono una volta
	fetchOptions: async context => {
		if (context.state.options) return context.state.options;
		const res = await axios.get(url(context, 'socialposts/options'), auth(context));
		context.commit('setOptions', res.data.data);
		return res.data.data;
	},
	fetchSettings: async context => (await axios.get(url(context, 'socialposts/settings'), auth(context))).data.data,
	saveSettings: async (context, payload) => (await axios.post(url(context, 'socialposts/settings'), { data: payload }, auth(context))).data.data,
	generatePlan: async context => axios.post(url(context, 'socialposts/plan'), {}, auth(context)),
	fetchDefaults: async context => (await axios.get(url(context, 'socialposts/defaults'), auth(context))).data.data,
	getDetail: async (context, payload) =>
		axios
			.get(url(context, `socialposts/${payload._id}`), auth(context))
			.then(res => res.data?.data)
			.catch(err => console.log('errore', err)),
	// salvataggio: gli errori arrivano al chiamante, che li mostra nella scheda
	save: async (context, form) => (await axios.post(url(context, form._id ? 'socialposts/update' : 'socialposts/store'), form, auth(context))).data.data,
	setStatus: async (context, { _id, status }) => (await axios.patch(url(context, `socialposts/${_id}/status`), { status }, auth(context))).data.data,
	publish: async (context, payload) => (await axios.post(url(context, `socialposts/${payload._id}/publish`), {}, auth(context))).data.data,
	deleteItem: async (context, payload) => axios.delete(url(context, `socialposts/${payload._id}`), auth(context)),
	preview: async (context, { post, format }) => (await axios.post(url(context, 'socialposts/preview'), { data: post, format }, auth(context))).data.data,
	download: async (context, { post, format }) => {
		const res = await axios.post(url(context, 'socialposts/download'), { data: post, format }, { ...auth(context), responseType: 'blob' });
		return res.data;
	},
	payoff: async (context, { item, lang }) => (await axios.post(url(context, 'socialposts/payoff'), { item, lang }, auth(context))).data.data,
	// template salvati
	fetchTemplates: async context => (await axios.get(url(context, 'socialposts/templates'), auth(context))).data.data,
	getTemplate: async (context, payload) =>
		axios
			.get(url(context, `socialposts/templates/${payload._id}`), auth(context))
			.then(res => res.data?.data)
			.catch(err => console.log('errore', err)),
	saveTemplate: async (context, form) => (await axios.post(url(context, form._id ? 'socialposts/templates/update' : 'socialposts/templates/store'), form, auth(context))).data.data,
	deleteTemplate: async (context, payload) => axios.delete(url(context, `socialposts/templates/${payload._id}`), auth(context)),
	destroyData: context => {
		context.commit('setItems', []);
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value;
	},
	setOptions: (state, value) => {
		state.options = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
